import { useDispatch, useSelector } from "@/core/redux/store";
import { InboxPageSection } from "./components/inbox";
import { useEffect, useRef } from "react";
import { getInbox } from "@/core/redux/thunks/inboxThunk";
import { trackNotificationReceived } from "@/lib/rum-actions";

export default function MailPage() {
  const me = useSelector((state) => state.user.me);
  const dispatch = useDispatch();
  const inbox = useSelector((state) => state.inbox.inbox);
  const trackedNotificationsRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (me && me.id) {
      dispatch(getInbox({ userId: me.id }));
    }
  }, [me]);

  // RUM-034: Track notification received for unread notifications
  useEffect(() => {
    if (inbox.data && inbox.data.length > 0) {
      inbox.data.forEach((notification) => {
        // Only track unread notifications that haven't been tracked in this session
        if (!notification.isRead && !trackedNotificationsRef.current.has(notification.id)) {
          trackNotificationReceived(
            notification.id,
            notification.type,
            notification.targetId
          );
          trackedNotificationsRef.current.add(notification.id);
        }
      });
    }
  }, [inbox.data]);

  return (
    <div>
      <InboxPageSection />
    </div>
  );
}
